import { Grid } from '@mantine/core';
import { useParams } from 'react-router';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const ViberMessagesStats = ({ stats, viberMessage, period, currency }) => {
  const { accountId, domainId } = useParams();

  const segmentLink = (preset) => {
    return `#/accounts/${accountId}/domains/${domainId}/segments/new?preset=${preset}&id=${viberMessage.id}&startDate=${period.startDate}&endDate=${period.endDate}`;
  };

  if (!stats) {
    return (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  }
  return (
    <>
      <Grid.Col span={12}>
        <Grid>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Sent"
              stats={stats}
              stat="sent"
              id={viberMessage.id}
              statKey="count"
              link={segmentLink('viberMessageSend')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Delivered"
              stats={stats}
              stat="deliveries"
              id={viberMessage.id}
              percentageOfStat="sent"
              statKey="count"
              link={segmentLink('viberMessageDelivery')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Opened"
              stats={stats}
              stat="opened"
              percentageOfStat="deliveries"
              id={viberMessage.id}
              statKey="count"
              link={segmentLink('viberMessageOpen')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Clicks"
              stats={stats}
              stat="clicks"
              percentageOfStat="opened"
              id={viberMessage.id}
              statKey="count"
              link={segmentLink('viberMessageClicks')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Conversions"
              stats={stats}
              stat="conversions"
              percentageOfStat="clicks"
              id={viberMessage.id}
              statKey="count"
              link={segmentLink('viberMessageConversion')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Purchases"
              stats={stats}
              stat="purchases"
              percentageOfStat="conversions"
              id={viberMessage.id}
              statKey="count"
              link={segmentLink('viberMessagePurchase')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Revenue"
              stats={stats}
              stat="purchases"
              id={viberMessage.id}
              statKey="value"
              currency={currency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
            <HeaderStatistic
              title="Unsubscribes"
              stats={stats}
              stat="unsubscribes"
              id={viberMessage.id}
              percentageOfStat="sent"
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Bounces"
              stats={stats}
              stat="bounces"
              id={viberMessage.id}
              statKey="count"
              link={segmentLink('viberMessageBounce')}
            />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </>
  );
};
export default ViberMessagesStats;
